import { Component, OnInit, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-placements-students-placed-list',
  templateUrl: './placements-students-placed-list.component.html',
  styleUrls: ['./placements-students-placed-list.component.scss']
})
export class PlacementsStudentsPlacedListComponent implements OnInit {

  constructor(private http: HttpClient, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  public lists = [];
  message = null;
  class = null;

  ngOnInit() {
    this.http.get<any>(this.api_endpoint+'/students-placed/').subscribe(
        data => {
          this.lists = data.data;
          // console.log(this.list_sections);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  }

  delete(id) {
    // console.log(this.Form.value)
    if(confirm("Are you sure to delete ")){
    this.http.delete<any>(this.api_endpoint+'/students-placed/'+ id).subscribe(
      res => {
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Deleted';
          this.class = 'btn btn-success';
          this.ngOnInit();
        }
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
  });
  }
  }

}
